export default __webpack_public_path__ + "static/media/globe2.b9c31465.png";